import React from 'react';
import './aiChat.scss';

var DEFAULT_ALLOWED_TENANT_IDS = [
  '187CB789-35F9-69A6-4BAD-3A03DF49F14A', '51db4de8-51f2-474e-84eb-65108cdb66ed'
];

var CHAT_IFRAME_SRC =
  'https://chat.callme.ai/guest?orgId=9bd75577-4f43-44d9-915f-3d729078c4e4&slotId=72f20381-b5f2-49b1-ae4b-633ea2255b21';

export class AiChat extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);

    this.state = {
      isChatOpen: !!props.defaultOpen
    };

    this.toggleChat = this.toggleChat.bind(this);
    this.openChat = this.openChat.bind(this);
    this.closeChat = this.closeChat.bind(this);
  }

  openChat() {
    this.setState({ isChatOpen: true }, function() {
      if (typeof window !== 'undefined' && typeof window.gtag_report_conversion === 'function') {
        window.gtag_report_conversion();
      }
    });
  }

  closeChat() {
    this.setState({ isChatOpen: false });
  }

  toggleChat() {
    if (this.state.isChatOpen) {
      this.closeChat();
    } else {
      this.openChat();
    }
  }

  isUserAllowed() {
    var currentTenant = {
  id: '51db4de8-51f2-474e-84eb-65108cdb66ed'
};

var currentUser = {
  isAuthenticated: true
};
    var allowedTenantIds = this.props.allowedTenantIds || DEFAULT_ALLOWED_TENANT_IDS;

    var tenantId =
      currentTenant && currentTenant.id
        ? currentTenant.id
        : null;

    var isAuthenticated =
      currentUser && currentUser.isAuthenticated
        ? currentUser.isAuthenticated
        : false;

    if (!tenantId || !isAuthenticated) {
      return false;
    }

    for (var i = 0; i < allowedTenantIds.length; i++) {
      if (
        allowedTenantIds[i] &&
        allowedTenantIds[i].toLowerCase() === tenantId.toLowerCase()
      ) {
        return true;
      }
    }

    return false;
  }

  render() {
    var buttonLabel = this.props.buttonLabel || 'CHAT WITH DIGGY';
    var headerLabel = this.props.headerLabel || 'Chat with Diggy';

    if (!this.isUserAllowed()) {
      return null;
    }

    return (
      <div className="ai-chat">
        <button
          type="button"
          className="chat-button"
          onClick={this.toggleChat}
        >
          {buttonLabel}
        </button>

        {this.state.isChatOpen ? (
          <div className="chat-window">
            <div className="chat-header">
              <span>{headerLabel}</span>
              <button
                type="button"
                className="close-button"
                onClick={this.closeChat}
                aria-label="Close chat"
              >
                ✖
              </button>
            </div>

            <iframe
              title="Chat with Diggy"
              src={CHAT_IFRAME_SRC}
              width="100%"
              height="100%"
              frameBorder="0"
              scrolling="no"
              allow="camera;microphone;fullscreen;clipboard-write"
            />
          </div>
        ) : null}
      </div>
    );
  }
}

export default AiChat;


// WEBPACK FOOTER //
// ./src/components/common/aiChat/aiChat.js